import type { StateCreator } from 'zustand';
import type { BrandIdentifiers, BrandSourceName } from '@/contexts/brand/sources/types';
import type { AppStore } from '../index';

// gloss
export type BrandSpace = 'hub' | 'global';

export type BrandScopeDeclaration = {
  sources: BrandSourceName[];
  space: BrandSpace;
  resource?: BrandIdentifiers;
};

export type BrandScopeSlice = {
  brandScope: BrandScopeDeclaration & {
    declare: (declaration: BrandScopeDeclaration) => void;
    reset: () => void;
  };
};

// gloss
export const HUB_BRAND_SCOPE: BrandScopeDeclaration = {
  sources: ['query', 'url', 'store', 'token'],
  space: 'hub',
  resource: undefined,
};

// why: these sources answer from what this browser remembers, not from the address being visited, so first paint must not treat them as the address naming a brand (ZLT-6041).
export const REMEMBERED_BRAND_SOURCES: readonly BrandSourceName[] = ['store', 'token'];

export const addressBrandSources = (sources: readonly BrandSourceName[]): BrandSourceName[] =>
  sources.filter((name) => !REMEMBERED_BRAND_SOURCES.includes(name));

export const createBrandScopeSlice: StateCreator<AppStore, [['zustand/devtools', never]], [], BrandScopeSlice> = (
  set,
) => ({
  brandScope: {
    ...HUB_BRAND_SCOPE,

    declare: (declaration) =>
      set((s) => ({ brandScope: { ...s.brandScope, ...declaration } }), false, 'brandScope/declare'),

    reset: () => set((s) => ({ brandScope: { ...s.brandScope, ...HUB_BRAND_SCOPE } }), false, 'brandScope/reset'),
  },
});
